import React from 'react';
import * as S from './styles';

type PageHeaderProps = {
  children?: React.ReactNode;
  className?: string;
  media?: React.ReactNode;
  title?: string;
  titleLogo?: React.ReactNode;
  titleSubnode?: React.ReactNode;
  right?: React.ReactNode;
  banner?: string;
  label?: React.ReactElement;
};

const PageHeader = (props: PageHeaderProps) => {
  const {
    children,
    media,
    title,
    titleLogo,
    titleSubnode,
    label,
    right,
  } = props;

  return (
    <S.Header {...props} verticallyCentered={!children}>
      <S.Media>
        {titleLogo}
        {media}
      </S.Media>
      <S.Content>
        {label}
        <S.TitleWrapper>
          <S.Title>{title}</S.Title>
          {titleSubnode}
        </S.TitleWrapper>
        {children}
      </S.Content>
      {right && <div>{right}</div>}
    </S.Header>
  );
};

export default PageHeader;
